import { render, staticRenderFns } from "./loading-indicator.vue?vue&type=template&id=0849b9e6&scoped=true&"
import script from "./loading-indicator.vue?vue&type=script&lang=ts&"
export * from "./loading-indicator.vue?vue&type=script&lang=ts&"
import style0 from "./loading-indicator.vue?vue&type=style&index=0&id=0849b9e6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0849b9e6",
  null
  
)

export default component.exports